import { useMatomo } from "@jonkoops/matomo-tracker-react";
import Button from "../../components/Button";

function InvestorsBox() {
    const { trackEvent } = useMatomo();

    const onButtonClick = (type: 'paper' | 'book-call') => {
        trackEvent({ category: 'investors box', action: `${type} button clicked` });
    }

    return (
        <div className="my-16 max-lg:p-5">
            <div className="flex flex-row justify-between items-center w-fit box m-auto px-10 py-5 border border-slate-100 rounded-xl max-sm:flex-col">
                <p className="text-slate-400 font-medium">
                    Interested in more information about investing in 3Folio? 
                </p>
                <Button text="Book a call" color="primary" size="small" className="mr-0 max-sm:m-2 max-sm:w-full max-sm:h-10" onClick={() => onButtonClick('book-call')}/>
                <Button text="Lite paper" color="secondary" size="small" className="max-sm:w-full max-sm:h-10" onClick={() => onButtonClick('paper')}/>
            </div>
        </div>
    )
};

export default InvestorsBox;